<template>
  <div class="line-chart-container">
    <div ref="chart" class="line-chart" :style="{ width: adaptiveWidth+ 'px', height: height + 'px' }"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'TrendLineChart',
  props: {
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 220
    },
    chartData: {
      type: Array,
      default: () => [
        { date: '2023-10-01', value: 120 },
        { date: '2023-10-02', value: 200 },
        { date: '2023-10-03', value: 150 },
        { date: '2023-10-04', value: 80 },
        { date: '2023-10-05', value: 70 },
        { date: '2023-10-06', value: 110 },
        { date: '2023-10-07', value: 130 }
      ]
    }
  },
  data() {
    return {
      chartInstance: null,
      windowWidth: window.innerWidth, // 存储当前窗口宽度
    }
  },
  computed: {
    // 核心：根据窗口宽度动态计算图表宽度（大屏1400px，小屏400px）
    adaptiveWidth() {
      return this.windowWidth <= 768 ? 400 : 1400;
    }
  },
  mounted() {
    this.initChart(); // 初始化图表（原有代码遗漏，必加）
    // 监听窗口缩放，更新窗口宽度并调整图表
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    initChart() {
      this.chartInstance = echarts.init(this.$refs.chart)
      this.updateChart()
    },
    updateChart() {
      const option = {
        backgroundColor: 'transparent',
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '5%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.chartData.map(item => item.date),
          axisLine: {
            lineStyle: {
              color: '#D8D8D8'
            }
          },
          axisLabel: {
            color: '#666'
          }
        },
        yAxis: {
          type: 'value',
          name: '事件趋势',
          nameTextStyle: {
            color: '#666',
            padding: [0, 0, 0, 40]
          },
          splitLine: {
            lineStyle: {
              color: '#F0F0F0'
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#666'
          }
        },
        series: [
          {
            name: '突发事件趋势',
            type: 'line',
            stack: '总量',
            smooth: true,
            lineStyle: {
              width: 3,
              color: '#1890FF'
            },
            showSymbol: false,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#77C6FE'
                },
                {
                  offset: 1,
                  color: '#ffffff'
                }
              ])
            },
            emphasis: {
              focus: 'series'
            },
            data: this.chartData.map(item => item.value)
          }
        ]
      }
      this.chartInstance.setOption(option)
    },
    handleResize() {
      this.windowWidth = window.innerWidth; // 更新窗口宽度，触发计算属性重新计算
      this.chartInstance && this.chartInstance.resize(); // 图表自适应新宽度
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.updateChart()
      }
    }
  }
}
</script>

<style scoped>
.line-chart-container {
  position: relative;
}

.line-chart {
  margin: 0 auto;
}
</style>
